export default {
  images: [],
  imagesByKeywords: [],
  read: {},
  isLoading: false
};
